import { useCallback, useEffect, useState } from 'react';

export interface FileSelectorProps {
  accept?: HTMLInputElement['accept'];
  multiple?: HTMLInputElement['multiple'];
  onChange: (files: FileList | null) => void;
}

export const useFileSelector = ({
  accept,
  multiple,
  onChange,
}: FileSelectorProps): { open: () => void } => {
  const [input] = useState<HTMLInputElement | null>(() => {
    if (typeof window === 'undefined') return null;
    const input = document.createElement('input');
    input.type = 'file';
    return input;
  });

  useEffect(() => {
    if (!input) return;

    input.accept = accept ?? '';
    input.multiple = !!multiple;

    input.onchange = () => {
      onChange?.(input.files);
    };
  }, [input, onChange, accept, multiple]);

  return {
    open: useCallback(() => {
      if (input) {
        input.value = '';
        input.click();
      }
    }, [input]),
  };
};
